

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import projectsModule from '@/store/projects'
import formulariosModule from '@/store/formularios'
import authenticationModule from '@/store/authentication'
import paymentModule from '@/store/payment'
import noticiasModule from '@/store/noticias'
import errorsModule from '@/store/errors'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import appinfo from '../../package.json';

let domain = "https://back.fundaciontomaspascualypilargomez-cuetara.org/";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname.includes("dev.doubledot.es")
) {
  domain = "https://dmb-pascual-donations.dev.doubledot.es/";
}

export const store = new Vuex.Store({
  state :{
    language: 'es',
    server : domain,
    packageVersion : appinfo.version
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
    getData:({dispatch}) => {
      dispatch('requestProyectos');
      dispatch('requestNoticias');
    }
  },
  getters : {
    getVersion : state => state.packageVersion,
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    }
  },
  modules :{
    projectsModule,
    formulariosModule,
    authenticationModule,
    paymentModule,
    noticiasModule,
    errorsModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js